const conf = require('./aws-config.json');

module.exports = {
    endpoint: conf.ApiUrl,
    authurl: conf.CognitoUrl,
    clientid: conf.CognitoClientId,
    eclassurl: conf.EclassUrl,
    stage: conf.Stage,
    canvasurl: conf.CanvasUrl,
    eclasscpdurl: conf.EclassCPDUrl,
};
